import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ServiceSix from "../elements/service/ServiceSix";
import ServiceEight from "../elements/service/ServiceEight";


const DigitalMarketing = () => {
    return (
        <>
            <SEO title="Bulk SMS"/>
            <Layout>
                <Separator/>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">Integration of Gateway Services & Bulk SMS</h3>
                                    <h4 className="title">To efficiently communicate with your customers, incorporate bulk text messaging into your application.</h4>
                                    <p className="mb--10">By integrating your application with a Bulk SMS API, you gain the ability
                                        to send messages to multiple phone numbers at once. Additionally,
                                        you can send personalized, automated messages to your clients with ease.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/split/bulksms.png" alt="split Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="content"><h4 className="title">With just one button click, send timely, pertinent communications to a huge group.</h4>
                                    <p className="mb--10">With our Bulk SMS service, you may relax if SMS Messaging is a crucial component of your
                                        business. Payment reminders, bill notifications, and marketing campaigns with scheduled &
                                        repeating SMS are all simple to send via our web portal or API.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Start Slider Area  */}
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="What Mixon will provide"
                                    description="To help our clients establish bulk SMS campaigns, engage their customers,
                                    and expand their businesses, we provide bulk SMS in Kenya. With the help of our Bulk SMS
                                    Services, Gateway Integration, and Bespoke Solutions, you may scale up text messaging."/>
                            </div>
                        </div>
                        {/* Start Slider Area  */}
                        {/* End Slider Area  */}
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default DigitalMarketing;
